import React from 'react'

const Rules = () => (
    <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.67247 13.1461V10.5611H3.08722V8.00082H0.477295V2.83046H3.06254L3.06241 0.243286H8.20776V2.80357H10.768V0.243286H15.9384V2.80357H18.5237V8.00107H16.0401V10.5614L13.4552 10.5612V13.1465H10.8699V15.7567H8.25998V13.146L5.67247 13.1461ZM10.8446 5.41571V7.97375H13.3526V5.41571H10.8446Z" fill="#FFC700"/>
    </svg>
)

export default Rules